import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { HomeSlider } from './slider/index';
import { routes } from '../../routes';
import { images } from '../../assets/images';
import { EqualHeight, EqualHeightElement } from 'react-equal-height';
import { ArticlesSlider } from './articles';
import { LatestWork } from './latestWork';
import { TechnologiesSlider } from './technologies';
import { TestimonialSlider } from './testimonials';
import { AccoladesSlider } from './accolades';
import { Animated } from 'react-animated-css';
import HomePageController from '../../apis/controller/homePage.controller';
import { renderImage } from "../../Components/helper/image";
import { dateFormat } from "../../Components/helper/date";

function HomePage() {
	const [homepage, setHomepage] = useState();
	const [loader, setLoader] = useState(false);

	useEffect(() => {
		getHomepage();
	}, []);

	const getHomepage = async () => {
		setLoader(true);
		let res = await new HomePageController().homePage();
		if (res && res.status) {
			setHomepage(res.home_page);
		}
		setLoader(false);
	};
	// var stripedHtml = cleanHtml.replace(/<[^>]+>/g, '');
	// console.log(homepage);
	return (
		<div className="homepage_section">
			<HomeSlider item={homepage ? homepage.slider_section : null} />
			<section className="about_section pt-5 pb-2">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="about_area">
								<div className="row">
									{homepage && homepage.about_us ? <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pb-5">
										<Animated animationIn="fadeInLeft" animationInDuration={700} animationInDelay={200} isVisible={true}>
											<div className="section_title right_line">
												<h2>{homepage.about_us.title}</h2>
												<div className="sub_title">
													<h3>{homepage.about_us.sub_title}</h3>
												</div>
											</div>
										</Animated>
										<Animated animationIn="fadeInLeft" animationInDuration={700} animationInDelay={400} isVisible={true}>
											<div className="cms_section text-justify ">
												<p>
													{homepage.about_us.description}
												</p>
											</div>
											<div className="secondary_btn">
												<Link to={routes}>Read More <i className="far fa-angle-right"></i></Link>
											</div>
										</Animated>
									</div> : null}
									{homepage && homepage.about_us ? <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 pb-5">
										<div className="advantages_section">
											{homepage.about_us.features != null || '' ? <>
												{homepage.about_us.features.map((item, index) => (
													<Animated key={index} animationIn="fadeInRight" animationInDuration={400} animationInDelay={200} isVisible={true}>
														<div className="advantage_item bg_secondary">
															<div className="d-flex">
																<div className="icon_area">
																	<img src={renderImage(item.image)} className="img-fluid" alt="..." />
																</div>
																<div className="content_area">
																	<h5>{item.title}</h5>
																	<p>{item.description.replace(/<[^>]+>/g, '')}</p>
																	
																</div>
															</div>
														</div>
													</Animated>
												))}
											</> : null}
											{/* <Animated animationIn="fadeInRight" animationInDuration={500} animationInDelay={300} isVisible={true}>
												<div className="advantage_item">
													<div className="d-flex">
														<div className="icon_area">
															<img src={images.icon1} className="img-fluid" alt="..." />
														</div>
														<div className="content_area">
															<h5>Full Satisfaction</h5>
															<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Soluta, doloribus ea. Consequuntur at consectetur unde voluptatibus quia nesciunt architecto veritatis?</p>
														</div>
													</div>
												</div>
											</Animated>
											<Animated animationIn="fadeInRight" animationInDuration={600} animationInDelay={500} isVisible={true}>
												<div className="advantage_item">
													<div className="d-flex">
														<div className="icon_area">
															<img src={images.icon1} className="img-fluid" alt="..." />
														</div>
														<div className="content_area">
															<h5>Full Satisfaction</h5>
															<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Soluta, doloribus ea. Consequuntur at consectetur unde voluptatibus quia nesciunt architecto veritatis?</p>
														</div>
													</div>
												</div>
											</Animated> */}
										</div>
									</div> : null}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="services_section bg-light pt-5 pb-4">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_services_section && <div className="services_area pb-3">
								<div className="section_title both_line text-center">
									<h2>{homepage.our_services_section.title}</h2>
								</div>
								<div className="services_items">
									<EqualHeight>
										<div className="row justify-content-center">
											{homepage.our_services_section.our_services != null || '' ? <>
												{homepage.our_services_section && homepage.our_services_section.our_services.map((item, index) => (
													<div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
														<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={400} isVisible={true}>
															<div className="service_item">
																<EqualHeightElement>
																	<div className="icon_area">
																		<Link to={routes.service}>
																			<img src={renderImage(item.image, 'small')} alt="..." className="img-fluid" />
																		</Link>
																	</div>
																	<div className="info_area">
																		<h4>
																			<Link to={routes.service}>{item.title}</Link>
																		</h4>
																		<p>{item.description.replace(/<[^>]+>/g, '')}</p>
																	</div>
																</EqualHeightElement>
															</div>
														</Animated>
													</div>
												))}
											</> : null}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={600} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>Web Design</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={800} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>Digital Marketing</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1000} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>App Development</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1200} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>Velidation Verification</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1400} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>CRM Development</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1600} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>E-commerce Websites</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={1800} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>Business Intelligence</Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
											{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
												<Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={2000} isVisible={true}>
													<div className="service_item">
														<EqualHeightElement>
															<div className="icon_area">
																<Link to={routes.service}>
																	<img src={images.icon3} alt="..." className="img-fluid" />
																</Link>
															</div>
															<div className="info_area">
																<h4>
																	<Link to={routes.service}>Custom Websites </Link>
																</h4>
																<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Odio praesentium quod accusantium iusto quis voluptatibus quam quidem quasi similique ipsam tenetur, earum culpa, ad corporis, recusandae delectus consequuntur</p>
															</div>
														</EqualHeightElement>
													</div>
												</Animated>
											</div> */}
										</div>
									</EqualHeight>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="process_section pt-5 pb-4" style={{ backgroundImage: `url(${images.polygonBG})` }}>
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_process_section && <div className="process_area d-none d-lg-block">
								<div className="section_title both_line text-center txt_white">
									<h2>{homepage.our_process_section.title}</h2>
								</div>
								<div className="process_item process_1">
									<Animated animationIn="zoomIn" animationInDuration={500} animationInDelay={2200} isVisible={true}>
										<div className="row align-items-center">
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_title">
													<h4>01</h4>
													<hr />
													<h2>Planning</h2>
												</div>
											</div>
											<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
												<div className="process_img">
													<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
												</div>
											</div>
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_content">
													<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
												</div>
											</div>
										</div>
									</Animated>
								</div>
								<div className="process_item process_2">
									<Animated animationIn="zoomIn" animationInDuration={500} animationInDelay={2550} isVisible={true}>
										<div className="row align-items-center">
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_content">
													<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
												</div>
											</div>
											<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
												<div className="process_img">
													<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
												</div>
											</div>
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_title">
													<h4>02</h4>
													<hr />
													<h2>Designing</h2>
												</div>
											</div>
										</div>
									</Animated>
								</div>
								<div className="process_item process_3">
									<Animated animationIn="zoomIn" animationInDuration={500} animationInDelay={2750} isVisible={true}>
										<div className="row align-items-center">
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_title">
													<h4>03</h4>
													<hr />
													<h2>Development</h2>
												</div>
											</div>
											<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
												<div className="process_img">
													<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
												</div>
											</div>
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_content">
													<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
												</div>
											</div>
										</div>
									</Animated>
								</div>
								<div className="process_item process_4">
									<Animated animationIn="zoomIn" animationInDuration={500} animationInDelay={3000} isVisible={true}>
										<div className="row align-items-center">
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_content">
													<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
												</div>
											</div>
											<div className="col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12">
												<div className="process_img">
													<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
												</div>
											</div>
											<div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
												<div className="process_title">
													<h4>04</h4>
													<hr />
													<h2>Deployment</h2>
												</div>
											</div>
										</div>
									</Animated>
								</div>
							</div>}
							<div className="process_area d-block d-lg-none">
								<div className="section_title both_line text-center txt_white">
									<h2>Our Process</h2>
								</div>
								<div className="process_item process_1">
									<div className="row align-items-center">
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_img">
												<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_title">
												<h4>01</h4>
												<hr />
												<h2>Planning</h2>
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_content">
												<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
											</div>
										</div>
									</div>
								</div>
								<div className="process_item process_2">
									<div className="row align-items-center">
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_img">
												<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_title">
												<h4>02</h4>
												<hr />
												<h2>Designing</h2>
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_content">
												<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
											</div>
										</div>
									</div>
								</div>
								<div className="process_item process_3">
									<div className="row align-items-center">
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_img">
												<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_title">
												<h4>03</h4>
												<hr />
												<h2>Development</h2>
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_content">
												<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
											</div>
										</div>
									</div>
								</div>
								<div className="process_item process_4">
									<div className="row align-items-center">
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_img">
												<img src={images.process1} alt="..." className="img-fluid d-block mx-auto" />
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_title">
												<h4>04</h4>
												<hr />
												<h2>Deployment</h2>
											</div>
										</div>
										<div className="col-md-12 col-sm-12 col-12">
											<div className="process_content">
												<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod laborum quaerat distinctio repellendus, cum, incidunt est illo quos illum molestias magni enim, id iste quasi nulla dolore dignissimos excepturi atque?</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="articles_section pt-5 pb-5 bg-light">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.articles_section && <div className="articles_area pb-3">
								<div className="section_title both_line text-center">
									<h2>{homepage.articles_section.title}</h2>
								</div>
								<ArticlesSlider item={homepage ? homepage.articles_section : null} />
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="work_section pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<div className="work_area pb-3">
								<div className="section_title both_line text-center">
									<h2>Our Latest Work</h2>
								</div>
								<Animated animationIn="zoomIn" animationInDuration={900} animationInDelay={4400} isVisible={true}>
									<LatestWork />
								</Animated>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="products_section bg-light pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_products_section && <div className="products_area">
								<div className="section_title both_line text-center">
									<h2>{homepage.our_products_section.title}</h2>
								</div>
								<div className="products_items">
									<div className="row justify-content-center">
										{homepage.our_products_section.our_products != null || '' ? <>
											{homepage.our_products_section && homepage.our_products_section.our_products.map((item, index) => (
												<div key={index} className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
													<div className="product_item">
														<div className="product_img">
															<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid d-block mx-auto" />
															<div className="upper_image">
																<div className="secondary_btn text-center">
																	<Link to={routes}>View Details <i className="far fa-angle-right"></i></Link>
																</div>
															</div>
														</div>
														<div className="product_info">
															<h4>{item.title}</h4>
															<p>{item.description}</p>
														</div>
													</div>
												</div>
											))}
										</> : null}
										{/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
											<div className="product_item">
												<div className="product_img">
													<img src={images.prod2} alt="..." className="img-fluid d-block mx-auto" />
													<div className="upper_image">
														<div className="secondary_btn text-center">
															<Link to={routes}>View Details <i className="far fa-angle-right"></i></Link>
														</div>
													</div>
												</div>
												<div className="product_info">
													<h4>Product Name Here</h4>
													<p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
												</div>
											</div>
										</div>
										<div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
											<div className="product_item">
												<div className="product_img">
													<img src={images.prod3} alt="..." className="img-fluid d-block mx-auto" />
													<div className="upper_image">
														<div className="secondary_btn text-center">
															<Link to={routes}>View Details <i className="far fa-angle-right"></i></Link>
														</div>
													</div>
												</div>
												<div className="product_info">
													<h4>Product Name Here</h4>
													<p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eos amet eius impedit placeat similique veniam adipisci libero quaerat voluptatum omnis.</p>
												</div>
											</div>
										</div> */}
									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="technologies_section pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.technology_partners_section && <div className="technologies_area">
								<div className="section_title both_line text-center txt_white">
									<h2>Technology Partners</h2>
								</div>
								<TechnologiesSlider item={homepage ? homepage.technology_partners_section : null} />
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="news_section pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.news_section && <div className="news_area">
								<div className="section_title both_line text-center">
									<h2>{homepage.news_section.title}</h2>
								</div>
								<div className="news_items">
									<div className="row">
										{homepage.news_section.news != null || '' ? <>
											{homepage.news_section && homepage.news_section.news.map((item, index) => (
												<div key={index} className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
													<div className="news_item">
														<Link to={routes}>
															<div className="news_img embed-responsive embed-responsive-16by9">
																<img src={renderImage(item.image, 'medium')} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
															</div>
															<div className="news_info">
																<div className="d-flex">
																	{item.categories.map((item, index) => (

																		<div key={index} className="category_name">
																			<span>{item.title}</span>
																		</div>
																	))}
																	<div className="news_date">
																		<span>{dateFormat(item.created)}</span>
																	</div>
																</div>
																<h4>{item.title}</h4>
															</div>
														</Link>
													</div>
												</div>
											))}
										</> : null}
										{/* <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
											<div className="news_item">
												<Link to={routes}>
													<div className="news_img embed-responsive embed-responsive-16by9">
														<img src={images.process2} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
													</div>
													<div className="news_info">
														<div className="d-flex">
															<div className="category_name">
																<span>Category Name</span>
															</div>
															<div className="news_date">
																<span>March 05, 2021</span>
															</div>
														</div>
														<h4>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto, illum</h4>
													</div>
												</Link>
											</div>
										</div> */}
									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="testimonials_section pt-5 pb-5" style={{ backgroundImage: `url(${images.process2})` }}>
				<div className="testimonials_area">
					<div className="container">
						<div className="row">
							{homepage && homepage.testimonials_section && <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
								<div className="section_title both_line text-center">
									<h2>Testimonials</h2>
								</div>
								<div className="row justify-content-center">
									<div className="col-xl-9 col-lg-10 col-md-11 col-sm-12 col-12">
										<TestimonialSlider item={homepage ? homepage.testimonials_section : null} />
									</div>
								</div>
							</div>}
						</div>
					</div>
				</div>
			</section>
			<section className="accolades_section pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							{homepage && homepage.our_accolades_section && <div className="accolades_area">
								<div className="section_title both_line text-center">
									<h2>Our Accolades</h2>
								</div>
								<AccoladesSlider item={homepage ? homepage.our_accolades_section : null} />
							</div>}
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default HomePage;
